import ABLE_TO_CREATE_NEW_LOAN from './ableToCreateNewLoan.gql';

export {
  // eslint-disable-next-line import/prefer-default-export
  ABLE_TO_CREATE_NEW_LOAN,
};
